import React from "react"
import { Link, graphql } from "gatsby"

import Header from "./../components/header"
import Layout from "../components/layout"
import SEO from "../components/seo"

export default function Home({ data }) {
  const hentSlides = data.hentData.edges.map(({ node }) => {
    return '';
  });
  return (
    <Layout>

      <SEO title="Expositions" />

      <div className="banner no-bg">
        <h1>Expositions</h1>
      </div>
      <div>
        <Link className="item-list" to="/hent">
          <div className="item-list-title">Hent</div>
          <div className="item-list-subtitle">Stéphane Lavoué</div>
        </Link>
      </div>
      <div>
        <Link className="item-list" to="/bistrot">
          <div className="item-list-title">Bistro</div>
          <div className="item-list-subtitle">« L‘autre abri du marin »</div>
        </Link>
      </div>
      <div>
        <Link className="item-list" to="/estacades">
          <div className="item-list-title">Les Estacades</div>
          <div className="item-list-subtitle">Les bateaux à flot du Port-Musée</div>
        </Link>
      </div>
    </Layout>
  )
}
      // <Header title="Retour au site" href="https://www.port-musee.org/" />

export const query = graphql`
  query {
    hentData: allMarkdownRemark(
      sort: { fields: [frontmatter___title], order: ASC }
      filter: {
        fields: {slug: { regex: "/^\\/hent/" }}
      }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            img {
              childImageSharp {
                fixed(height: 160) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
          fields {
            slug
          }
        }
      }
    }
  }
`
